<template>
<div class="chapter">
<div class="inner_page">
<p class="cn" id="ch3">ANCESTORS MAJESTIC</p>
<p class="v">Majestic, O ancestors majestic</p>
<p class="v">ablaze shaping blessings this</p>
<p class="v">bounty on and on stretching</p>
<p class="v">boundless across your lands:</p>
<p class="v">we bring you crystalline wine</p>
<p class="v">and you answer our prayers.</p>
<p class="v">We bring well-seasoned soup,</p>
<p class="v">approach mindful and tranquil</p>
<p class="v">and hushed in silent homage,</p>
<p class="v">leaving all strife far behind,</p>
<p class="v">and you ease our pained brows,</p>
<p class="v">letting old age grow boundless.</p>
<p class="v">Hubs veiled and harness inlaid,</p>
<p class="v">eight phoenix-bells clittering,</p>
<p class="v">we offer sacrifice and homage.</p>
<p class="v">The Mandate we received is vast and mighty.</p>
<p class="v">It’s from Heaven—this rich ease,</p>
<p class="v">this life abounding in harvests.</p>
<p class="v">We offer homage, and you accept,</p>
<p class="v">sending boundless good fortune,</p>
<p class="v">honoring autumn and winter</p>
<p class="v">offerings from T’ang’s children.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?1eb22f6b